module.exports = __webpack_public_path__ + "0beb89ba5b99145702e9a410617b76f9.png";